export default __webpack_public_path__ + "static/media/image-add.839eaa57.svg";